import React, {Component} from "react";
import PropTypes from "prop-types";
import {observer, PropTypes as MobxPropTypes} from 'mobx-react';
import client from "../session/apiClient";
import * as mobx from "mobx";
import {SearchToSelect} from "../../components";
import EnumEditorGoogleAttributes from "../../modules/admin/manageLocations/google/EnumEditorGoogleAttributes";
import BoolEditorGoogleAttributes from "../../modules/admin/manageLocations/google/BoolEditorGoogleAttributes";
import UrlEditorGoogleAttributes from "../../modules/admin/manageLocations/google/UrlEditorGoogleAttributes";
import RepeatedEnumEditorGoogleAttributes from "../../modules/admin/manageLocations/google/RepeatedEnumEditorGoogleAttributes";
import GoogleAttributesStore from "./GoogleAttributesStore";


const _ = require('lodash');

class GoogleAttributesSelector extends Component {

    static propTypes = {
        placeholder: PropTypes.string,
        selected: MobxPropTypes.arrayOrObservableArray,
        onSelect: PropTypes.func.isRequired,
        isInvalid: PropTypes.func.isRequired,
        multi: PropTypes.bool,
        disabled: PropTypes.bool,
        locationIds: MobxPropTypes.arrayOrObservableArray,
        googleAttributesStore: PropTypes.instanceOf(GoogleAttributesStore) // Can be supplied to remove reloading of categories
    };

    state = {
        availableGoogleAttributes: [],
        attributesError: null,
        isLoading: false
    }

    constructor(props){
        super(props);
        this.loadAttributes()
    }

    componentDidMount() {
        // this.loadAttributes();
    }
    componentDidUpdate() {
        // this.loadAttributes();
    }

    loadAttributes(){
        const selectedLocations = this.props.locationIds || []
        const singleLocationMode = selectedLocations.length === 1
        const attributesPromise = singleLocationMode
            ? this.props.googleAttributesStore.loadAttributesForLocation(selectedLocations[0])
            : this.props.googleAttributesStore.loadAllAttributes()

        this.setState({
            isLoading: true
        })
        attributesPromise.then(attributes => {
            if (this.props.googleAttributesStore.attributesError !== null) {
                this.setState({
                    attributesError: this.props.googleAttributesStore.attributesError,
                    availableGoogleAttributes: [],
                    isLoading: false
                })
            } else {
                this.setState({
                    attributesError: null,
                    availableGoogleAttributes: attributes,
                    isLoading: false
                })
            }
        })
    }


    mySelect = (theSelectionsAsDisplayNames) => {
        const selectionsInGoogleFormat= this.cmAttributesToGoogleAttributes(theSelectionsAsDisplayNames)
        const newStuff = selectionsInGoogleFormat.filter(googleAtt => !this.props.selected.map(cmAtt => cmAtt.attributeId).includes(googleAtt.attributeId))
        const cmSelections = newStuff.map(googleAttribute => this.makeDefaultObj(googleAttribute) ).concat(this.props.selected)
        this.props.onSelect(cmSelections)
    }

    makeDefaultObj = (googleAttribute) => {
        if(googleAttribute.valueType == "BOOL") {
            return {attributeId: googleAttribute.attributeId, valueType: googleAttribute.valueType, values: [true]}
        } else if (googleAttribute.valueType == "REPEATED_ENUM"){
            return {attributeId: googleAttribute.attributeId, valueType: googleAttribute.valueType, repeatedEnumValue: {setValues: [], unsetValues: googleAttribute.valueMetadata.map(metadata => metadata.value)} }
        } else {
            return {attributeId: googleAttribute.attributeId, valueType: googleAttribute.valueType}
        }
    }

    cmAttributesToGoogleAttributes = (displayNames) => {
      const googleAtts =   this.state.availableGoogleAttributes.filter(googleAtt => displayNames.includes(googleAtt.displayName))
        return googleAtts
    }

    invalidUrlAttribute = () =>  {
        const urlAtts = this.props.selected.filter(att => att.valueType === "URL")
        const isValidUrl = (string) => {
            try {
                new URL(string);
            } catch (_) {
                return false;
            }
            return true;
        }
        const allFilledIn = urlAtts.map(att => att.urlValues).every(Boolean)
        const allValid = urlAtts.flatMap(att => att.urlValues).filter(Boolean).map(obj => obj.url).every(url => isValidUrl(url))
        return !(allValid && allFilledIn)
    }

    invalidNonUrlAttributes = () => {
        const attributesWithValues = this.props.selected.filter(att => att.valueType === "ENUM" || att.valueType === "BOOL")
        const allValid1 = attributesWithValues.map(att => att.values).filter(Boolean).every(values => values[0]!=undefined)//Make sure all the values have been defined. ie not null.
        const repeatedEnumAttributes = this.props.selected.filter(att => att.valueType === "REPEATED_ENUM")
        const allValid2 = repeatedEnumAttributes.every(att => att.repeatedEnumValue.setValues?.length>0)
        return ! (allValid1  && allValid2)
    }

    invalidAttributes = () => {
        return this.invalidUrlAttribute() ||  this.invalidNonUrlAttributes()
    }

    attributeUpdated = (attribute) => {
        const update = this.props.selected.filter(cmAtt => cmAtt.attributeId != attribute.attributeId).concat([attribute])
        this.props.onSelect(update)
    }

    attributeUnselected = (cmAttUnselected) => {
        const update = this.props.selected.filter(cmAtt => cmAtt.attributeId != cmAttUnselected.attributeId)
        this.props.onSelect(update)
    }


    render() {
        const inValid = this.invalidAttributes()
        this.props.isInvalid(this.invalidAttributes())

        //for some reason placeholder was one draw behind
        const {selected, multi, disabled, googleCategoriesStore} = this.props;

        let placeholder = this.state.isLoading ? "Loading..." : "Select..."
        const allValues = this.state.availableGoogleAttributes.map(att => att.displayName).sort()
        const selectedValues  = this.state.availableGoogleAttributes.filter(att1 => selected.map(att2 => att2.attributeId).includes(att1.attributeId)).map(att3 => att3.displayName)
        const googleAtts = this.state.availableGoogleAttributes.filter(att => selectedValues.includes(att.displayName))
        return <div>
            {!!this.state.attributesError && <div className="invalid-feedback" style={{"display": "block"}}>{this.state.attributesError}</div>}
            <SearchToSelect
                placeholder={this.props.placeholder || placeholder}
                multi={multi}
                disabled={disabled || this.state.isLoading || !!this.state.attributesError}
                options={allValues}
                renderMultiSelected={() => this.props.placeholder || placeholder || (multi ? "Attributes" : "Attribute")}
                onSelected={this.mySelect}
                getKey={x => x}
                getSearchResults={({query}) => this.search(query)}
                selected={selectedValues}
            />
            {googleAtts.map(att => {
                return <div key={att.attributeId}>
                    {att.valueType === "ENUM" &&
                    <EnumEditorGoogleAttributes
                        googleAttribute = {att}
                        cmAttribute = {selected.filter(cmAtt => cmAtt.attributeId === att.attributeId)[0]}
                        key = {att.attributeId}
                        onChange = {this.attributeUpdated}
                        onDelete={this.attributeUnselected}
                    />
                    }
                    {att.valueType === "REPEATED_ENUM" &&
                    <RepeatedEnumEditorGoogleAttributes
                        googleAttribute = {att}
                        cmAttribute = {selected.filter(cmAtt => cmAtt.attributeId === att.attributeId)[0]}
                        key = {att.attributeId}
                        onChange = {this.attributeUpdated}
                        onDelete={this.attributeUnselected}
                    />
                    }
                    {att.valueType === "BOOL" &&
                    <BoolEditorGoogleAttributes
                        googleAttribute = {att}
                        cmAttribute = {selected.filter(cmAtt => cmAtt.attributeId === att.attributeId)[0]}
                        key = {att.attributeId}
                        onChange = {this.attributeUpdated}
                        onDelete={this.attributeUnselected}
                    />
                    }
                    {att.valueType === "URL" &&
                    <UrlEditorGoogleAttributes
                        googleAttribute = {att}
                        cmAttribute = {selected.filter(cmAtt => cmAtt.attributeId === att.attributeId)[0]}
                        key = {att.attributeId}
                        onChange = {this.attributeUpdated}
                        onDelete={this.attributeUnselected}
                    />
                    }
                </div>

            })}

        </div>



    }

    search = (query) => {
        const attributes = this.state.availableGoogleAttributes.map(att => att.displayName);
        const lowercase = query.toLowerCase();
        return attributes.filter(att => att.toLowerCase().includes(lowercase)).sort();
    };

}

GoogleAttributesSelector.defaultProps = {
    multi: true, // Multi select by default
    disabled: false,
    googleCategoriesStore: new GoogleAttributesStore()
};

export default GoogleAttributesSelector;